module.provider('Notifications', function() {

    var default_ttl = 5000;
    var canned_messages = {
        form_errors: {
            message: 'There are errors on the form. Please correct them and submit the form again.',
            type: "error",
            ttl: default_ttl,
        }
    };


    function Notification(index, service, message, type, ttl) {
        this.message = message;
        this.ttl = ttl;
        this.type = type;
        this.index = index;

        this.remove = function() {
            service.remove(this);
        }
    }

    function NotificationService($timeout) {
        this._counter = 0;
        this._notifications = [];

        Object.defineProperty(this, 'messages', {
            get: function() {
                return this._notifications;
            }
        });

        this.add = function(message, type, ttl) {
            var index = this._counter++,
                note = new Notification(index, this, message, type, ttl);

            if (angular.isUndefined(ttl)) {
                ttl = default_ttl;
            }

            this._notifications.unshift(note);

            if (ttl > 0) {
                $timeout(function() {
                    note.remove();
                }, ttl);
            }

            return note;
        };

        this.error = function(message, ttl) {
            this.add(message, 'error', ttl);
        };

        this.warning = function(message, ttl) {
            this.add(message, 'warning', ttl);
        };

        this.success = function(message, ttl) {
            this.add(message, 'success', ttl);
        };

        this.canned = function(name) {
            if (canned_messages[name]) {
                var message = canned_messages[name];
                this.add(message.message, message.type, message.ttl);
            }
        };


        this.remove = function(note) {
            var index = this._notifications.indexOf(note);
            if (index > -1) {
                this._notifications.splice(index, 1);
            }
        };

        this.clearAll = function() {
            this._notifications.splice(0, this._notifications.length);
        }
    }

    this.$get = function($timeout) {
        return new NotificationService($timeout);
    };
});